require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-being-non-racist-is-not-enough.json") })
        }
      }, "path---blog-being-non-racist-is-not-enough");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-being-non-racist-is-not-enough!./.cache/json/blog-being-non-racist-is-not-enough.json
// module id = 720
// module chunks = 231608221292675